import Splide from "@splidejs/splide";

export const reviewSliderInit = () => {
  const reviewSliders = document.querySelectorAll('.review-slider');

  if(reviewSliders) {
    reviewSliders.forEach((item) => {
      const reviewSlider = new Splide(item, {
        type: 'carousel',
        perPage: 1,
			  perMove: 1,
        pagination: false,
			  gap: '13px',
        autoplay: false,
        rewind: true,
        speed: 600,
        mediaQuery: 'min',
        breakpoints: {
          1025: {
            perPage: 2,
			      gap: '13px'
          },
          620: {
            perPage: 2,
			      gap: '13px'
          },
        }
      });

      reviewSlider.mount();
    });
  }
}